"use client";

import { TEvent } from "@/types/event";
import Image from "next/image";
import { Button } from "../ui/button";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { TSettings } from "@/types/settings";
import { TCouponCategory } from "@/types/coupon";

export default function CouponSidebar({
  couponCategory,
  events,
  settings,
  onClose,
}: {
  couponCategory: TCouponCategory | null;
  events: TEvent[];
  settings: TSettings;
  onClose: () => void;
}) {
  const router = useRouter();

  const goToCheckout = () => {
    router.push("/coupon-checkout/" + couponCategory?.id);
  };

  const [localEvents, setLocalEvents] = useState<TEvent[]>([]);

  useEffect(() => {
    if (couponCategory && events) {
      if (
        couponCategory.activityCategories &&
        couponCategory.activityCategories.length > 0
      ) {
        const eve = events
          .filter(
            (e) =>
              e.extendedProps.isPublic &&
              +e.start - (settings.latestCheckoutHours || 24) * 3600 * 1000 >
                +new Date() &&
              e.extendedProps.availableSlots > 0
          )
          .slice(0, 5);
        setLocalEvents(eve);
      } else {
        const eve = events
          .filter(
            (e) =>
              e.extendedProps.isRegular &&
              +e.start - (settings.latestCheckoutHours || 24) * 3600 * 1000 >
                +new Date() &&
              e.extendedProps.availableSlots > 0
          )
          .slice(0, 5);
        setLocalEvents(eve);
      }
    }
  }, [events, couponCategory]);

  return (
    <div className="p-4 radius-base relative">
      <Button
        className="absolute top-2 right-4 p-2 rounded-full bg-muted"
        variant="outline"
        onClick={() => onClose()}
      >
        X
      </Button>
      <h2
        className="text-base-text font-bold text-2xl font-domine border-b-2"
        style={{
          borderColor:
            couponCategory?.activityCategories?.[0]?.color ||
            "var(--primary-text)",
        }}
      >
        {couponCategory?.title}
      </h2>
      <div className="relative">
        {couponCategory ? (
          <Image
            className="mt-3 w-full"
            width={600}
            height={448}
            src={
              couponCategory?.image ||
              couponCategory?.activityCategories?.[0]?.image ||
              ""
            }
            alt={couponCategory?.title || ""}
            unoptimized={true}
          />
        ) : (
          <></>
        )}
        <div className="absolute top-2 right-2 bg-secondary-text text-md font-bold text-muted pt-1 pb-1 pl-3 pr-3 rounded-full">
          {couponCategory?.packs ? "Desde " : ""}
          {couponCategory?.activityCategories &&
          couponCategory?.activityCategories.length > 0
            ? couponCategory?.price
            : Math.min(
                ...(couponCategory?.packs || [])
                  .filter((p) => p.isPubliclyVisible)
                  .map((p) => p.price)
              )}
          €
        </div>
      </div>
      {localEvents[0] ? (
        <div className="text-sm text-center mt-4 mb-4 font-bold">
          Próxima clase:{" "}
          {localEvents[0].start.toLocaleTimeString("es", {
            month: "long",
            day: "2-digit",
            hour: "2-digit",
            timeZone: "Europe/Madrid",
          })}
          -
          {localEvents[0].end.toLocaleTimeString("es", {
            hour: "2-digit",
            // minute: "2-digit",
            hour12: false,
            timeZone: "Europe/Madrid",
          })}
          h
        </div>
      ) : (
        <></>
      )}

      {couponCategory?.activityCategories &&
      couponCategory?.activityCategories.length > 0 ? (
        <div className="mt-8 mb-4 p-4 text-center text-sm bg-quaternary-bg radius-base border-1 border-base-text border-dashed">
          Todos los vales tienen una validez de {settings.couponValidForDays}{" "}
          días y se pueden utilizar en cualquier clase de{" "}
          {couponCategory?.title}.
        </div>
      ) : (
        <div className="mt-8 mb-4 p-4 text-center text-sm bg-quaternary-bg radius-base border-1 border-base-text border-dashed">
          Todos los vales tienen una validez de {settings.couponValidForDays}{" "}
          días y se pueden utilizar en cualquier clase de Pack de clases
          regulares. Una vez reservada la primera clase del pack, tienes{" "}
          {settings.packValidForDays} días para terminar las clases.
        </div>
      )}
      <div className="flex justify-center m-2 mt-10">
        <Button onClick={() => goToCheckout()}>Comprar vale ahora</Button>
      </div>

      <div
        className="text-sm p-2 mt-4"
        dangerouslySetInnerHTML={{
          __html: couponCategory?.description || "",
        }}
      ></div>

      {/* {couponCategory?.packs ? (
        <div className="text-sm p-2 mt-4">
          <p>Elige el pack que deseas regalar.</p>
          <div>
            <Combobox
              singleSelection={true}
              label=""
              hideCloseBtn={true}
              selectedLabel=""
              selectedAllLabel=""
              data={couponCategory.packs
                .filter((p) => p.isPubliclyVisible)
                .map((p) => ({
                  value: p.id,
                  label: `${p.description} ~ ${new Intl.NumberFormat("es", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(p.price)}€ ~ válido hasta ${new Date(
                    +new Date() + p.validForDays * 24 * 3600 * 1000
                  ).toLocaleDateString("es-ES", {
                    month: "long",
                    day: "2-digit",
                    year: "numeric",
                  })}`,
                  active: true,
                }))}
              placeholder=""
              notFoundLabel=""
              onValueChange={(values) => {
                // setPack(packs.find((p) => p.id === values[0].value) || packs[0]);
              }}
              defaultValues={[
                {
                  value: couponCategory?.packs[0].id,
                  label: `${
                    couponCategory?.packs[0].description
                  } ~ ${new Intl.NumberFormat("es", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(
                    couponCategory?.packs[0].price
                  )}€ ~ válido hasta ${new Date(
                    +new Date() +
                      couponCategory?.packs[0].validForDays * 24 * 3600 * 1000
                  ).toLocaleDateString("es-ES", {
                    month: "long",
                    day: "2-digit",
                    year: "numeric",
                  })}`,
                  active: true,
                },
              ]}
            />
          </div>
        </div>
      ) : (
        <></>
      )} */}

      {localEvents.length > 0 ? (
        <div className="text-center mt-2 mb-4 font-bold text-2xl border-t-1 pt-4">
          Próximas clases:
        </div>
      ) : (
        <></>
      )}
      <div>
        {localEvents.map((event, key) => (
          <div
            key={event.id || key}
            className="flex flex-row items-center justify-center text-center p-4 border-b-1"
          >
            <div className="text-sm pt-2 text-center">
              <div className="font-bold">{event.title}</div>
              <span className="text-xs">
                {event?.start.toLocaleString("es", {
                  month: "long",
                  day: "2-digit",
                  // hour: "2-digit",
                  timeZone: "Europe/Madrid",
                })}
                ,{" "}
                {event?.start.toLocaleTimeString("es", {
                  hour: "2-digit",
                  timeZone: "Europe/Madrid",
                })}
                -
                {event?.end.toLocaleTimeString("es", {
                  hour: "2-digit",
                  // minute: "2-digit",
                  hour12: false,
                  timeZone: "Europe/Madrid",
                })}
                h
              </span>
              <div className="text-sm mt-2">
                Plazas disponibles: {event?.extendedProps.availableSlots}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 flex justify-center mb-6">
        <Button onClick={() => goToCheckout()}>Comprar vale ahora</Button>
      </div>
    </div>
  );
}
